export const RESIZE_OBSERVER_LOOP_ERROR_CHROME =
  'ResizeObserver loop limit exceeded'

export const RESIZE_OBSERVER_LOOP_ERROR_FIREFOX =
  'ResizeObserver loop completed with undelivered notifications.'
